export default __webpack_public_path__ + "static/media/homepage.0beef50f.jpeg";